﻿import React, {ReactNode, useEffect, useId, useState} from 'react';
import {
  FormControlStandard,
  FormInputItemFlexContainer,
  FormInputItemFullWidthContainer,
  ToggleIconButton,
  ToggleIconContainer
} from "@securspace/securspace-ui-kit";
import {SelectChangeEvent} from "@mui/material";
import {ArrowDropDown, ArrowDropUp} from "@mui/icons-material";
import {SortDirType} from "../../../../types/common/SortDirType";
import {SlotType} from "../../../../types/Slots";
import {useSlotOrDefault} from "../../../../hooks/slots/useSlotOrDefault";
import { SortFilterSelect } from "../../reports/sortFilter/SortFilterSelect";
import {SortFilterInputLabel} from "../../reports/sortFilter/SortFilterInputLabel";

type SortSelectProps<T> = {
  sortBy: T;
  onSortByChange: (value: T) => void;
  sortDir: SortDirType;
  onSortDirChange: (value: SortDirType) => void;
  label?: SlotType;
  children: ReactNode;
}

const SortSelect = <T extends "" | string | undefined,>({sortBy, onSortByChange, sortDir, onSortDirChange, label, children}: SortSelectProps<T>) => {
  const [activeState, setActiveState] = useState(sortDir === 'asc');

  // generate id to connect label/input
  const uid = useId();

  // handlers
  const handleSortByChange = (event: SelectChangeEvent<T>) => {
    onSortByChange(event?.target.value as T);
  }

  // custom hooks
  useEffect(() => {
    const actual = activeState ? 'asc' : 'desc';
    if (sortDir !== actual) {
      onSortDirChange(actual);
    }
  }, [activeState, onSortDirChange, sortDir]);

  // slots
  const Label = useSlotOrDefault(label, SortFilterInputLabel, {id: uid})

  return <FormInputItemFlexContainer>
    <FormInputItemFullWidthContainer>
      <FormControlStandard>
        {Label}
        <SortFilterSelect labelId={uid}
                          value={sortBy}
                          onChange={handleSortByChange}
        >
          {
            children
          }
        </SortFilterSelect>
      </FormControlStandard>
    </FormInputItemFullWidthContainer>
    <ToggleIconContainer onClick={() => setActiveState(prevState => !prevState)}>
      <ToggleIconButton activeState={activeState}>
        <ArrowDropUp fontSize={'large'} />
      </ToggleIconButton>
      <ToggleIconButton activeState={!activeState}>
        <ArrowDropDown fontSize={'large'} />
      </ToggleIconButton>
    </ToggleIconContainer>
  </FormInputItemFlexContainer>
}

export default SortSelect;
